import Hero from './Hero';
import DeveloperJourney from './DeveloperJourney';
import EventsCarousel from './EventsCarousel';
import DeveloperRelationsTeam from './DeveloperRelationsTeam';

import React, { useEffect } from 'react';

function RedirectComponent() {
  useEffect(() => {
    window.location.href = 'https://www.symphony.com/support/developers/';
  }, []);

  return (
    <div>
      <p></p>
    </div>
  );
}

export default RedirectComponent;

/*export default () => (
    <>
        <Hero />
        <DeveloperJourney />
        <EventsCarousel />
        <DeveloperRelationsTeam />
    </>
);
*/
